import * as React from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, name, style, value, ...other } = props;
  // mask를 style에 실어 넘기면 입력 요소의 CSS mask가 되어 글자 위치가 깨진다.
  const { mask, definitions, ...domStyle } = style || {};
  const skipInitialEmptyRef = React.useRef(true);
  return (
    <IMaskInput
      {...other}
      value={value}
      {...(Object.keys(domStyle).length > 0 ? { style: domStyle } : {})}
      mask={mask}
      definitions={definitions}
      inputRef={ref}
      onAccept={(next) => {
        const current = value ?? '';
        if (next === current) return;
        if (skipInitialEmptyRef.current) {
          skipInitialEmptyRef.current = false;
          if (!next && current) return;
        }
        onChange({ target: { name, value: next } });
      }}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextMaskCustom;